import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/autoplay';

function AchaImageCarouselContained() {
  if (!document.body.classList.contains('acha')) return;

  const carouselElements = document.querySelectorAll('.image-carousel-swiper--contained .swiper:not(.no-swiper)');

  if (!carouselElements.length > 0) return;

  carouselElements.forEach((el) => {
    const btnNext = el.parentElement.querySelector('.swiper-button-next');
    const btnPrev = el.parentElement.querySelector('.swiper-button-prev');
    const paginationEl = el.querySelector('.swiper-pagination');
    const isAutoPlay = false;

    const swiper = new Swiper(el, {
      direction: 'horizontal',
      loop: true,
      a11y: true,
      keyboardControl: true,
      autoHeight: true,
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 1000,
      modules: [Navigation, Pagination, Autoplay],
      navigation: {
        nextEl: btnNext,
        prevEl: btnPrev,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      breakpoints: {
        320: {
          autoplay: { enabled: false },
        },
        768: {
          autoplay: {
            delay: 5000,
            enabled: isAutoPlay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
          slidesPerView: 1,
          centeredSlides: false,
          spaceBetween: 20,
        },
      },
    });

    // Get the height to the slider
    function getSlideMediaHeight() {
      const slideMedia = el.querySelector('.swiper-slide img, .swiper-slide iframe, .swiper-slide video');
      const slideMediaHeight = slideMedia?.getBoundingClientRect().height;
      return slideMediaHeight;
    }

    if (getSlideMediaHeight() > 0) {
      el.style.setProperty('--image-carousel-height', `${getSlideMediaHeight()}px`);
    }
    swiper.on('beforeResize', function () {
      if (getSlideMediaHeight() > 0) {
        el.style.setProperty('--image-carousel-height', `${getSlideMediaHeight()}px`);
      }
    });
  });
}


function RdnImageCarouselContained() {
  if (!document.body.classList.contains('rdn')) return;

  const carouselElements = document.querySelectorAll('.image-carousel-swiper--contained .swiper:not(.no-swiper)');

  if (!carouselElements.length) return;

  const pageRightColumn = document.querySelector('.page-right-column');
  const carouselContainer = document.querySelector('.image-carousel-container');

  carouselElements.forEach((el) => {
    const btnNext = el.parentElement.querySelector('.swiper-button-next');
    const btnPrev = el.parentElement.querySelector('.swiper-button-prev');
    const paginationEl = el.querySelector('.swiper-pagination');


    // Function to calculate layout and slide width
    const updateLayout = (swiperInstance) => {
      const bodyWidth = document.body.clientWidth;
      const containerPaddingLeft = carouselContainer.getBoundingClientRect().left;

      let calculatedWidth;
      let spaceBetween = bodyWidth < 992 ? 8 : 16;

      if (bodyWidth < 992) {
        calculatedWidth = pageRightColumn.clientWidth + (bodyWidth - pageRightColumn.clientWidth);
        el.style.transform = `translateX(-${containerPaddingLeft}px)`;
      } else {
        calculatedWidth = carouselContainer.clientWidth;
        el.style.transform = `translateX(0)`;
      }

      el.style.width = `${calculatedWidth}px`;

      // Update each slide width
      const allSlides = el.querySelectorAll('.swiper-slide');
      allSlides.forEach((slide) => {
        if (bodyWidth < 1200) {
          slide.style.width = `${pageRightColumn.clientWidth}px`;
        } else {
          slide.style.width = `87.5%`;
        }
      });

      // Update Swiper's spaceBetween value
      if (swiperInstance) {
        swiperInstance.params.spaceBetween = spaceBetween;
        // swiperInstance.update();
      }
    };
    
    // Initialize Swiper
    const swiper = new Swiper(el, {
      modules: [Navigation, Pagination, Autoplay],
      // loop: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 16,
      speed: 500,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: btnNext,
        prevEl: btnPrev,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      on: {
        init() {
          updateLayout(this);
        },
      },
    });

    // Update layout when window is resized
    window.addEventListener('resize', () => {
      updateLayout(swiper);
      // swiper.loopDestroy();
      // swiper.loopCreate();
    });
  });
}
  

window.addEventListener('load', () => {
  AchaImageCarouselContained();
  RdnImageCarouselContained();
});